import type { CV, FullCV } from '@cibli/shared';

import api from '@/services/api.ts';

export const translateCV = async (
  cvId: string,
  options?: { targetLanguage?: string },
): Promise<{
  cvTranslated: CV;
  fullCvTranslated?: FullCV;
}> => {
  const url = `/cv/${cvId}/translate`;
  return await api.patch<
    {
      cvTranslated: CV;
      fullCvTranslated?: FullCV;
    },
    { targetLanguage?: string }
  >(url, { targetLanguage: options?.targetLanguage });
};

export const deleteCV = async (cvId: string): Promise<void> => {
  const url = `/cv/${cvId}`;
  await api.delete<void>(url);
};
